import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { CoreModule } from "../../core/core.module";
import { BannerManagementComponent } from "./banner-management/banner-management";
import { AdministratorRoutingModule } from "./administrator-routing.module";
import { SharedModule } from "../../shared/shared.module";
import { ManagementComponent } from "./management";
import {
    CLActColComponent,
    FilterPhotoManagement,
} from "./filter-photo-management/filter-photo-management";
import { FilterPhotoForm } from "./filter-photo-form/filter-photo-form";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthCamerallaInterceptor } from "../../auth/interceptors/auth.interceptor";
import { DemoMaterialModule } from "./material-module";
import { ErrorCamerallaInterceptor } from "../../auth/interceptors/error.interceptor";
import { PopupManagement } from "./popup-management/popup-management";
import { BannerPhotoComponent } from "./banner-photo/banner-photo";
import { MobileBannerPhotoComponent } from "./mobile-banner-photo/mobile-banner-photo";
import { AdvertisingManagement } from "./advertising-management/advertising-management";
import { AdvertisingPhotoComponent } from "./advertising-photo/advertising-photo";
import {
    AppManagementComponent,
    PresetActionColComponent,
} from "./app-management/app-management-component";
import { CustomNotificationFormComponent } from "./app-management/custom-notification-form/custom-notification-form-component";
import { PresetFormComponent } from "./app-management/preset-form/preset-form-component";
import { PointManagement } from "./point-management/point-management";
import { AddPointComponent } from "./point-management/add-point/add-point-component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CustomNgbModalService } from "../../shared/classes/CustomNgbModalService";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CoreModule,
        SharedModule,
        AdministratorRoutingModule,
        DemoMaterialModule,
    ],
    exports: [
        ManagementComponent,
        BannerManagementComponent,
        FilterPhotoManagement,
        FilterPhotoForm,
        DemoMaterialModule,
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthCamerallaInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorCamerallaInterceptor,
            multi: true,
        },
        { provide: NgbModal, useClass: CustomNgbModalService },
    ],
    entryComponents: [
        ManagementComponent,
        BannerManagementComponent,
        FilterPhotoManagement,
        FilterPhotoForm,
        CLActColComponent,
        PopupManagement,
        BannerPhotoComponent,
        MobileBannerPhotoComponent,
        AdvertisingManagement,
        AdvertisingPhotoComponent,
        AppManagementComponent,
        CustomNotificationFormComponent,
        ManagementComponent,
        PresetFormComponent,
        PresetActionColComponent,
        AddPointComponent,
    ],
    declarations: [
        ManagementComponent,
        BannerManagementComponent,
        FilterPhotoManagement,
        FilterPhotoForm,
        CLActColComponent,
        PopupManagement,
        BannerPhotoComponent,
        MobileBannerPhotoComponent,
        AdvertisingManagement,
        AdvertisingPhotoComponent,
        AppManagementComponent,
        CustomNotificationFormComponent,
        PresetFormComponent,
        PresetActionColComponent,
        PointManagement,
        AddPointComponent,
    ],
})
export class AdministratorModule {}
